import { http } from '@/support/http'
import { createQuery } from '@/support/utils/paginatorQueryBuilder'
import { parseToFormDataWithArray } from '@/support/payloadParser'

export const getArticlesList = (pagination) => {
  const queryString = createQuery(pagination)

  return http.get(`api/articles?${queryString}`)
}

export const toggleFeaturedArticle = (idArticle) => {
  return http.patch(`api/article/${idArticle}/toggle-featured`)
}

export const publishArticle = (idArticle) => {
  return http.patch(`api/article/${idArticle}/publish`)
}

export const hideArticle = (idArticle) => {
  return http.patch(`api/article/${idArticle}/hide`)
}

export const removeArticle = (idArticle) => {
  return http.delete(`api/article/${idArticle}`)
}

export const getArticle = (idArticle) => {
  return http.get(`api/article/${idArticle}`)
}

const buildArticleForm = (payload) => {
  const data = { ...payload }
  const coverFile = data.cover_image && typeof data.cover_image === 'object' ? data.cover_image : null
  const cardFile = data.card_image && typeof data.card_image === 'object' ? data.card_image : null
  const ogFile = data.og_image && typeof data.og_image === 'object' ? data.og_image : null
  const ogClear = data.og_image === ''
  const faqs = Array.isArray(data.faqs) ? data.faqs : null
  const linkRels = Array.isArray(data.link_rels) ? data.link_rels : null
  const redirects = Array.isArray(data.redirects) ? data.redirects : null
  const recommendations = Array.isArray(data.recommendations) ? data.recommendations : null

  if (coverFile) delete data.cover_image
  if (cardFile) delete data.card_image
  if (ogFile || ogClear) delete data.og_image
  if (faqs !== null) delete data.faqs
  if (linkRels !== null) delete data.link_rels
  if (redirects !== null) delete data.redirects
  if (recommendations !== null) delete data.recommendations

  delete data.og_image_resolved

  Object.keys(data).forEach((key) => {
    if (data[key] === null || data[key] === undefined) {
      delete data[key]
    }
  })

  const form = parseToFormDataWithArray(data)

  if (coverFile) {
    form.append('cover_image', coverFile, coverFile.name)
  }

  if (cardFile) {
    form.append('card_image', cardFile, cardFile.name)
  }

  if (ogFile) {
    form.append('og_image', ogFile, ogFile.name)
  } else if (ogClear) {
    form.append('og_image', '')
  }

  if (faqs !== null) {
    form.append('faqs', JSON.stringify(faqs))
  }

  if (linkRels !== null) {
    form.append('link_rels', JSON.stringify(linkRels))
  }

  if (redirects !== null) {
    form.append('redirects', JSON.stringify(redirects))
  }

  if (recommendations !== null) {
    form.append('recommendations', JSON.stringify(recommendations))
  }

  return form
}

const multipartHeaders = { headers: { 'Content-Type': 'multipart/form-data' } }

export const createArticle = (payload) => {
  return http.post('api/article', buildArticleForm(payload), multipartHeaders)
}

export const updateArticle = (idArticle, payload) => {
  return http.post(`api/article/${idArticle}`, buildArticleForm(payload), multipartHeaders)
}

export const checkArticleSlug = (slug, excludeId) => {
  const params = { slug }

  if (excludeId) {
    params.exclude_id = excludeId
  }

  return http.get('api/articles/slug-availability', { params })
}

export const getThemesList = () => {
  return http.get('api/themes?filter[active]=1&page=1&limit=1000')
}
